export default "__VITE_ASSET__DHiLUpeM__"